export default "__VITE_ASSET__C7tbUs67__"